
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing-policy",
      function () {
        return require("private-next-pages/pricing-policy.tsx");
      }
    ]);
  